import PageShell from "../components/PageShell";
import { viewsFor } from "../content/views";
import seoPages from "../content/seo-pages.json";

const views = viewsFor("expertise");
const seo = seoPages["/expertise"];

export default function Expertise() {
  return (
    <PageShell
      title={seo.title}
      description={seo.description}
      bodyClass=""
      dataFrame={null}
      views={views}
    />
  );
}
